import { render, staticRenderFns } from "./EmployeeGroupPageForm.vue?vue&type=template&id=61252411&scoped=true&"
import script from "./EmployeeGroupPageForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeGroupPageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61252411",
  null
  
)

export default component.exports